import { ItemView } from '@glu/core';

import template from './auxControl.hbs';

export default ItemView.extend({
  template,
  className: 'aux-control',

  events: {
    'click .js-clear-filters': 'clearFilters'
  },

  collectionEvents: {
    'grid:filter:change': 'render'
  },

  initialize() {
    this.filterProc = this.options.filterProc;
    this.filters = this.filterProc.filters;

    if (!this.filters) {
      return;
    }

    this.listenTo(this.filters, 'refresh', this.render);
  },

  templateHelpers() {
    return {
      filtersEnabled: !this.filters.isEmpty()
    };
  },

  clearFilters(e) {
    e.preventDefault();

    this.filterProc.clear();
  }
});
